export default __webpack_public_path__ + "static/media/specific_month.92dfaca8.jpg";